/**  保存图标 */ 
export const save:string = require('./save.png')

/** 坐标图标 */ 
export const coord:string = require('./coord.png')

/** 长度测量图标 */ 
export const lengthMeasurement:string = require('./lengthMeasurement.png')

/** 图层图标 */ 
export const layer:string = require('./layer.png')

/** 鼠标事件图标 */ 
export const mouseEvent:string = require('./mouseEvent.png')

/** 闪烁特效图标 */ 
export const flickerSpecialEffect:string = require('./flickerSpecialEffect.png')

/** 全图显示图标 */ 
export const fullDisplay:string = require('./fullDisplay.png')

/** 批注图标 */ 
export const notation:string = require('./notation.png')


/** 面积测量图标 */ 
export const areaMeasurement:string = require('./areaMeasurement.png')

/** 两点之间移动效果图标 */ 
export const moveEffectBetweenTwoPoints:string = require('./moveEffectBetweenTwoPoints.png')


/** 绘图图标 */ 
export const draw:string = require('./draw.png')


/** 打印图标 */ 
export const print:string = require('./print.png')

/** 窗口缩放图标 */ 
export const windowZoom:string = require('./windowZoom.png')

/** 布局图标 */ 
export const layout:string = require('./layout.png')